import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setStartSlotandCourseIdAtom = atom(
  null,
  (
    get,
    set,
    { startSlotId, courseId }: { startSlotId: string; courseId: string }
  ) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;
    set(currentBookingAtom, { ...booking, startSlotId, courseId });
  }
);
